module.exports = __webpack_public_path__ + "media/images/recruitment/pinterest/pinterest-1-9296549413212900c8379ee496c78a63.jpg";